export default __webpack_public_path__ + "static/media/tbi.b05134da.webp";